const genericGridStyle = {
	
};

export default genericGridStyle;